import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getAlgoliaDataHitsResultsByArtworkId } from 'selectors/algolia2/data'
import { getIsMobileTraffic } from 'selectors/shared/mobileTraffic'
import { getTitle, getSeoCategory } from '../selectors/app'
import { getUserID } from 'selectors/user/session'
const mapStateToProps = createStructuredSelector({
  artwork: (state, props) => getAlgoliaDataHitsResultsByArtworkId(props.artworkId)(state),
  isMobileTraffic: getIsMobileTraffic,
  category: getSeoCategory,
  title: getTitle,
  userID: getUserID,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  artwork: Record<string, any>
  isMobileTraffic: boolean
  category: string
  title: string
  userID: number
}
export default connect(mapStateToProps, mapDispatchToProps)
